(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cz-app5-popup"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('cz-app5-popup')) return;

  class CZApp5Popup extends HTMLElement {
    connectedCallback() {
      if (this._bound) return;
      if (!this.querySelector('[data-dialog]')) {
        this._ready = () => this.connectedCallback();
        document.addEventListener('DOMContentLoaded', this._ready, { once: true });
        return;
      }
      this._bound = true;
      this._abort = new AbortController();
      this._timers = new Set();
      this._queue = [];
      this._sent = new Set();
      this._flushing = false;
      this._submitting = false;
      this._flipEpoch = 0;
      this._flipping = false;
      this._revealed = false;
      this._storageKey = 'cz_app5_popup_v1';
      this._pendingKey = 'cz_app5_pending_v1';
      try { this.config = JSON.parse(this.dataset.config || '{}'); } catch (_) { this.config = {}; }
      this.strings = this.config;
      try { this.local = window.localStorage; } catch (_) {}
      try { this.session = window.sessionStorage; } catch (_) {}
      this.dialog = this.querySelector('[data-dialog]');
      this.overlay = this.querySelector('[data-overlay]');
      this.form = this.querySelector('[data-signup-form]');
      this.email = this.querySelector('[data-email]');
      this.live = this.querySelector('[data-live]');
      this.stage = 'cards';
      this.card = '';
      this.interactionId = this.newId();
      this.demo = Boolean(window.Shopify?.designMode) || this.dataset.designMode === 'true' ||
        new URL(location.href).searchParams.get('cz_app5_preview') === '1';
      this.storage = this.read(this.local, this._storageKey) || {};
      this.pending = this.read(this.session, this._pendingKey);
      if (this.pending && (!Number.isFinite(this.pending.at) || Date.now() - this.pending.at > 7200000 ||
          this.pending.formId !== this.form?.id)) {
        this.remove(this.session, this._pendingKey);
        this.pending = null;
      }
      const on = (el, type, fn) => el?.addEventListener(type, fn, { signal: this._abort.signal });
      this.querySelectorAll('[data-card]').forEach(el => { el.dataset.originalLabel = el.getAttribute('aria-label') || ''; on(el, 'click', () => this.pickCard(el)); });
      on(this.querySelector('[data-claim]'), 'click', () => { if (this._revealed) this.showStage('email', true); });
      this.querySelectorAll('[data-close]').forEach(el => on(el, 'click', () => this.dismiss()));
      on(this.querySelector('[data-back]'), 'click', () => this.showStage('cards', true));
      on(this.dialog, 'cancel', event => { event.preventDefault(); this.dismiss(); });
      on(this.dialog, 'click', event => {
        if (event.target !== this.dialog) return;
        const r = this.dialog.getBoundingClientRect();
        if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.dismiss();
      });
      on(this.dialog, 'close', () => { this.cancelFlip(); if (this.stage === 'cards') this.resetCards(); if (this.overlay) this.overlay.hidden = true; this.unlock(); });
      on(this.overlay, 'click', () => this.dismiss());
      on(document, 'keydown', event => this.keyboard(event));
      on(this.form, 'submit', event => this.submit(event));
      on(this.querySelector('[data-copy]'), 'click', () => this.copy());
      this.querySelectorAll('[data-store]').forEach(el => on(el, 'click', () => this.track('store_click', { store_target: el.dataset.store })));
      this.querySelectorAll('[data-preview-stage]').forEach(el => on(el, 'click', () => {
        if (this.demo) { this.card = this.card || '1'; this.showStage(el.dataset.previewStage, true); this.open(false); }
      }));
      on(document, 'shopify:section:select', event => {
        if (this.demo && (event.detail?.sectionId === this.dataset.sectionId || event.target?.contains(this))) this.open(false);
      });
      on(window, 'pageshow', event => {
        if (event.persisted) {
          this.cancelFlip();
          if (this.stage === 'cards') this.resetCards();
          this.setSubmitting(false);
          const saved = this.read(this.local, this._storageKey) || {};
          if (Number(saved.completeUntil) > Date.now() && this.dialog.open) {
            this.dialog.close();
          } else if (!this.read(this.session, this._pendingKey) && this.stage === 'email') this.showStage('email', false);
        }
      });
      const android = /Android/i.test(navigator.userAgent);
      this.dataset.preferredStore = android ? 'android' : 'ios';
      const preferred = this.querySelector(`[data-store="${this.dataset.preferredStore}"]`);
      if (preferred?.parentElement) preferred.parentElement.prepend(preferred);
      if (this.demo) {
        this.dataset.previewMode = 'true';
        this.showStage(['cards', 'email', 'reward'].includes(this.config.editorStage) ? this.config.editorStage : 'cards');
        this.later(() => this.open(false), 180);
        return;
      }
      if (this.restoreSubmission()) return;
      if (this.suppressed()) return;
      const delay = Math.max(0, Number(this.config.delay ?? 12)) * 1000;
      this.later(() => this.tryOpen(0), delay);
    }

    disconnectedCallback() {
      document.removeEventListener('DOMContentLoaded', this._ready);
      this.cancelFlip();
      this._abort?.abort();
      this._timers?.forEach(id => clearTimeout(id));
      if (this.dialog?.open) this.dialog.close();
      this.unlock();
      this._bound = false;
    }

    newId() {
      return window.crypto?.randomUUID?.() || 'cz_' + Date.now().toString(36) + '_' + Math.random().toString(36).slice(2, 12);
    }

    read(storage, key) {
      try { return JSON.parse(storage.getItem(key) || 'null'); } catch (_) { return null; }
    }

    write(storage, key, value) {
      try { storage.setItem(key, JSON.stringify(value)); return true; } catch (_) { return false; }
    }

    remove(storage, key) { try { storage.removeItem(key); } catch (_) {} }

    later(fn, ms) {
      const id = setTimeout(() => { this._timers.delete(id); if (this.isConnected) fn(); }, ms);
      this._timers.add(id);
      return id;
    }

    excluded() {
      const url = new URL(location.href);
      const path = url.pathname.replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/)/i, '');
      if (/^\/(?:cart|checkout|checkouts|account|challenge|password)(?:\/|$)/i.test(path)) return true;
      if ([...url.searchParams.keys()].some(key => key.toLowerCase() === 'mystery')) return true;
      if (/cz-recover|mystery(?:%3d|=)/i.test(url.hash + url.search)) return true;
      return false;
    }

    suppressed() {
      const state = this.read(this.local, this._storageKey) || {};
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      return (mobile && this.config.showMobile === false) || (!mobile && this.config.showDesktop === false) || this.config.enabled === false || this.dataset.knownSubscriber === 'true' || this.excluded() ||
        Number(state.dismissUntil) > Date.now() || Number(state.completeUntil) > Date.now();
    }

    otherDialog() {
      return [...document.querySelectorAll('dialog[open], [role="dialog"][aria-modal="true"], #shopify-pc__banner')]
        .some(el => el !== this.dialog && !this.contains(el) && el.getClientRects().length > 0 &&
          getComputedStyle(el).visibility !== 'hidden' && getComputedStyle(el).display !== 'none');
    }

    tryOpen(retries) {
      if (this.suppressed()) return;
      if (document.hidden || this.otherDialog()) {
        if (retries < 60) this.later(() => this.tryOpen(retries + 1), 2000);
        return;
      }
      this.showStage('cards');
      this.open(true);
    }

    open(countView) {
      if (!this.dialog || typeof this.dialog.show !== 'function' || this.dialog.open) return;
      this._focusBefore = document.activeElement;
      if (this.overlay) this.overlay.hidden = false;
      this.dialog.show();
      this.querySelector(`section[data-stage="${this.stage}"] h3`)?.focus({ preventScroll: true });
      document.documentElement.classList.add('cz-app5-scroll-lock');
      if (countView) this.track('view');
    }

    keyboard(event) {
      if (!this.dialog?.open || !this.dialog.contains(document.activeElement)) return;
      if (event.key === 'Escape') { event.preventDefault(); this.dismiss(); return; }
      if (event.key !== 'Tab' || this._submitting) return;
      const items = [...this.dialog.querySelectorAll('button:not(:disabled), a[href], input:not([type="hidden"]):not(:disabled), [tabindex="0"]')]
        .filter(el => el.getClientRects().length > 0);
      if (!items.length) return;
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) {
        event.preventDefault(); last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first.focus();
      }
    }

    unlock() {
      if (!document.querySelector('cz-app5-popup dialog[open]')) document.documentElement.classList.remove('cz-app5-scroll-lock');
    }

    dismiss() {
      if (!this.dialog.open) return;
      this.track('dismiss');
      if (!this.demo && this.stage !== 'reward') {
        const state = this.read(this.local, this._storageKey) || {};
        state.dismissUntil = Date.now() + Number(this.config.dismissDays ?? 7) * 86400000;
        this.write(this.local, this._storageKey, state);
      }
      this.dialog.close();
      this.unlock();
      if (this._focusBefore?.isConnected && this._focusBefore !== document.body) this._focusBefore.focus({ preventScroll: true });
    }

    cancelFlip() {
      this._flipEpoch = (this._flipEpoch || 0) + 1;
      if (this._flipTimer) { clearTimeout(this._flipTimer); this._timers?.delete(this._flipTimer); }
      if (this._advanceTimer) { clearTimeout(this._advanceTimer); this._timers?.delete(this._advanceTimer); }
      this._flipCleanup?.();
      this._flipCleanup = null;
      this._flipping = false;
    }

    resetCards() {
      this.cancelFlip();
      this._revealed = false;
      this.card = '';
      delete this.dataset.picked;
      delete this.dataset.revealed;
      delete this.dataset.selectedCard;
      this.querySelectorAll('[data-card]').forEach(el => {
        el.classList.remove('is-selected', 'is-flipped');
        el.disabled = false;
        el.setAttribute('aria-pressed', 'false');
        el.setAttribute('aria-label', el.dataset.originalLabel || '');
      });
      const claim = this.querySelector('[data-claim]');
      const hint = this.querySelector('[data-reveal-hint]');
      const cardHint = this.querySelector('[data-card-hint]');
      if (cardHint) cardHint.hidden = false;
      if (claim) claim.hidden = true;
      if (hint) hint.hidden = true;
    }

    pickCard(el) {
      if (this.stage !== 'cards' || this._flipping || this._revealed || !this.dialog?.open) return;
      this.cancelFlip();
      const epoch = this._flipEpoch;
      this._flipping = true;
      this.card = el.dataset.card;
      this.dataset.selectedCard = this.card;
      this.dataset.picked = 'true';
      this.querySelectorAll('[data-card]').forEach(card => {
        card.disabled = card !== el;
        card.setAttribute('aria-pressed', card === el ? 'true' : 'false');
      });
      el.classList.add('is-selected');
      this.track('card_select');
      const inner = el.querySelector('[data-card-inner]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let finished = false;
      const finish = () => {
        if (finished || epoch !== this._flipEpoch || !this.isConnected || !this.dialog.open || this.stage !== 'cards') return;
        finished = true;
        this._flipCleanup?.();
        this._flipCleanup = null;
        this._flipping = false;
        this._revealed = true;
        this.dataset.revealed = 'true';
        const claim = this.querySelector('[data-claim]');
        const hint = this.querySelector('[data-reveal-hint]');
        if (claim) claim.hidden = false;
        if (hint) hint.hidden = false;
        const cardHint = this.querySelector('[data-card-hint]');
        if (cardHint) cardHint.hidden = true;
        const announcement = (this.config.revealAnnouncement || '').replaceAll('[percent]', String(this.config.percent || 5));
        if (this.live) { this.live.classList.add('cz-app5__sr-only'); this.live.textContent = announcement; }
        if (announcement) el.setAttribute('aria-label', announcement);
        if (this.config.autoAdvance === true) {
          this._advanceTimer = this.later(() => {
            if (epoch === this._flipEpoch && this.dialog.open && this.stage === 'cards') this.showStage('email', true);
          }, Math.max(500, Number(this.config.revealHold ?? 1200)));
        }
      };
      if (inner) {
        const end = event => { if (event.target === inner && event.propertyName === 'transform') finish(); };
        inner.addEventListener('transitionend', end);
        this._flipCleanup = () => inner.removeEventListener('transitionend', end);
      }
      void el.offsetWidth;
      el.classList.add('is-flipped');
      this._flipTimer = this.later(finish, reducedMotion ? 16 : Math.max(0, Number(this.config.flipDuration ?? 800)) + 100);
    }

    showStage(stage, focus = false) {
      if (!['cards', 'email', 'reward'].includes(stage)) return;
      this.cancelFlip();
      if (stage === 'cards') this.resetCards();
      this.stage = stage;
      this.dataset.stage = stage;
      this.querySelectorAll('[data-stage]').forEach(el => { el.hidden = el.dataset.stage !== stage; });
      if (this.live) { this.live.textContent = ''; this.live.classList.remove('cz-app5__sr-only'); }
      if (focus) this.later(() => {
        const el = stage === 'email' ? this.email : this.querySelector(`section[data-stage="${stage}"] button, section[data-stage="${stage}"] a`);
        el?.focus({ preventScroll: true });
      }, 40);
    }

    setSubmitting(busy) {
      this._submitting = busy;
      if (busy) this.form?.setAttribute('aria-busy', 'true');
      else this.form?.removeAttribute('aria-busy');
      const label = this.querySelector('[data-submit] > span:not([aria-hidden])');
      if (label) label.textContent = busy ? this.strings.submitting : this.strings.submitLabel;
    }

    submit(event) {
      if (this.demo) {
        event.preventDefault();
        if (this.form.reportValidity()) this.showStage('reward', true);
        return;
      }
      if (!this.form.checkValidity()) return;
      if (this._submitting) return;
      this.setSubmitting(true);
      const pending = { formId: this.form.id, card: this.card, at: Date.now(), path: location.pathname,
        interactionId: this.interactionId, viewTracked: this._sent.has('view') };
      this.write(this.session, this._pendingKey, pending);
      this.track('submit_attempt');
      this.later(() => this.setSubmitting(false), 12000);
    }

    restoreSubmission() {
      if (!this.pending) return false;
      const state = this.querySelector('[data-form-state]');
      this.card = ['1', '2', '3'].includes(this.pending.card) ? this.pending.card : '1';
      this.setAttribute('data-selected-card', this.card);
      this.interactionId = this.pending.interactionId || this.newId();
      if (this.pending.viewTracked) this._sent.add('view');
      if (state?.dataset.error === 'true') {
        this.remove(this.session, this._pendingKey);
        this.showStage('email');
        this.open(false);
        this.later(() => this.email?.focus(), 60);
        return true;
      }
      if (state?.dataset.success === 'true') {
        this.remove(this.session, this._pendingKey);
        const saved = this.read(this.local, this._storageKey) || {};
        saved.completeUntil = Date.now() + Number(this.config.revealDays ?? 180) * 86400000;
        this.write(this.local, this._storageKey, saved);
        this.showStage('reward');
        this.open(false);
        if (this.pending.viewTracked) this.track('submit_success');
        return true;
      }
      this.remove(this.session, this._pendingKey);
      this.showStage('email');
      const retry = this.querySelector('[data-retry]');
      if (retry) retry.hidden = false;
      this.open(false);
      return true;
    }

    async copy() {
      const code = (this.querySelector('[data-code]')?.textContent || this.config.code || 'APP5').trim();
      let success = false;
      try {
        if (navigator.clipboard?.writeText) { await navigator.clipboard.writeText(code); success = true; }
      } catch (_) {}
      if (!success) {
        const field = document.createElement('textarea');
        field.value = code;
        field.style.cssText = 'position:fixed;opacity:0;pointer-events:none';
        this.dialog.appendChild(field);
        field.select();
        try { success = document.execCommand('copy'); } catch (_) {}
        field.remove();
      }
      if (this.live) this.live.textContent = success ? (this.strings.copied || 'Code copied. See you in the app.') :
        (this.strings.copyFallback || 'Your code is APP5. Enter it at checkout in the app.');
      if (success) this.track('copy_code');
    }

    track(action, extra = {}) {
      if (this.demo) return;
      if (['view', 'submit_success'].includes(action)) {
        if (this._sent.has(action)) return;
        this._sent.add(action);
      }
      this._queue.push({ action, popup_id: this.dataset.popupId || 'cz_app5_v1', selected_card: this.card,
        interaction_id: this.interactionId, store_target: extra.store_target || '' });
      this.flush(0);
    }

    flush(attempt) {
      if (this._flushing) return;
      if (typeof window.Shopify?.analytics?.publish === 'function') {
        while (this._queue.length) {
          const data = this._queue.shift();
          try { window.Shopify.analytics.publish('cz_app5_popup', data); } catch (_) {}
        }
      } else if (attempt < 12 && this._queue.length) {
        this._flushing = true;
        this.later(() => { this._flushing = false; this.flush(attempt + 1); }, 800);
      }
    }
  }
  customElements.define('cz-app5-popup', CZApp5Popup);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cz-mystery-discount"] && !Shopify.designMode) return;
  try {
    

(() => {
  if (customElements.get('cz-mystery-discount')) return;
  const entryUrl = new URL(location.href);
  let claimed = false;
  const reducedMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const sameCode = (a, b) => String(a || '').trim().toUpperCase() === String(b || '').trim().toUpperCase();
  const rootUrl = () => `${(window.Shopify?.routes?.root || '/').replace(/\/$/, '')}/`;
  const publish = (name, data) => {
    try { window.Shopify?.analytics?.publish?.(name, { path: location.pathname, ...data }); } catch {}
  };
  const fetchJson = async (url, options = {}) => {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 6000);
    try {
      const response = await fetch(url, {
        credentials: 'same-origin', cache: 'no-store', ...options,
        headers: { Accept: 'application/json', ...options.headers }, signal: controller.signal,
      });
      if (!response.ok) throw new Error(`HTTP ${response.status}`);
      return await response.json();
    } finally { clearTimeout(timer); }
  };

  class CzMysteryDiscount extends HTMLElement {
    async connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const { signal } = this.abort;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      try { this.config = JSON.parse(this.dataset.config); }
      catch { return; }
      this.entryUrl = this.readEntryUrl();
      this.code = '';
      this.designMode = this.hasAttribute('data-design-mode');
      this.sectionId = this.dataset.sectionId;
      this.endsAt = this.parseEnd(this.config.endsAt);
      this.invalidEnd = Boolean(this.config.endsAt) && this.endsAt === null;
      this.applied = this.querySelector('[data-cz-md-applied]');
      this.appliedText = this.querySelector('[data-cz-md-applied-text]');
      this.appliedSub = this.querySelector('[data-cz-md-applied-sub]');
      this.announcement = this.querySelector('[data-cz-md-announcement]');
      this.countdown = this.querySelector('[data-cz-md-countdown]');
      this.dialog.addEventListener('click', this.onClick, { signal });
      this.dialog.addEventListener('cancel', (event) => { event.preventDefault(); this.close('escape'); }, { signal });
      this.dialog.addEventListener('close', () => this.unlockScroll(), { signal });
      if (this.designMode) { this.setupEditor(signal); return; }
      const trigger = await this.findTrigger();
      if (signal.aborted || !this.isConnected || !trigger || claimed) return;
      this.trigger = trigger;
      this.code = trigger.code;
      this.recoveryUrl = this.config.allowRecovery ? this.findRecovery() : null;
      if (!this.config.active || this.invalidEnd || this.expired()) {
        if (this.recoveryUrl) {
          claimed = true;
          this.cleanUrl();
          location.replace(this.recoveryUrl.href);
        }
        return;
      }
      claimed = true;
      this.cleanUrl();
      this.applyPromise = this.recoveryUrl
        ? Promise.resolve({ state: 'recovery', cart: null })
        : this.invalidRecovery
          ? Promise.resolve({ state: 'invalid-recovery', cart: null })
          : this.applyCode();
      const start = () => { this.openTimer = setTimeout(() => this.open(this.trigger.type), 350); };
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true, signal });
      else start();
    }

    disconnectedCallback() {
      this.abort?.abort();
      ['openTimer', 'revealTimer', 'statusTimer', 'closeTimer', 'slowTimer'].forEach((key) => clearTimeout(this[key]));
      clearInterval(this.tick);
      if (this.dialog?.open) this.dialog.close();
      this.unlockScroll();
    }

    parseEnd(value) {
      if (!value) return null;
      const match = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2})(?::(\d{2}))?(Z|[+-]\d{2}:\d{2})$/.exec(value);
      if (!match) return null;
      const [, year, month, day, hour, minute, second = '00'] = match;
      const days = new Date(Date.UTC(Number(year), Number(month), 0)).getUTCDate();
      if (+month < 1 || +month > 12 || +day < 1 || +day > days || +hour > 23 || +minute > 59 || +second > 59) return null;
      const time = Date.parse(value);
      return Number.isFinite(time) ? time : null;
    }

    expired() { return this.endsAt !== null && Date.now() >= this.endsAt; }

    readEntryUrl() {
      const url = new URL(entryUrl.href);
      const param = String(this.config.param || 'mystery').toLowerCase();
      const explicit = [...url.searchParams].filter(([key]) => key.toLowerCase() === param);
      if (url.hash || explicit.length !== 1) return url;
      const [key, value] = explicit[0];
      const marker = value.indexOf('#cz-recover=');
      if (marker < 1 || value.indexOf('#', marker + 1) !== -1) return url;
      const fragment = value.slice(marker + 1);
      const parts = [...new URLSearchParams(fragment)];
      if (parts.length !== 1 || parts[0][0] !== 'cz-recover' || !parts[0][1]) return url;
      url.searchParams.set(key, value.slice(0, marker));
      url.hash = fragment;
      return url;
    }

    async matchesCode(candidate) {
      const normalized = String(candidate || '').trim().toUpperCase();
      const expected = String(this.config.codeHash || '').toLowerCase();
      if (!normalized || !/^[a-f0-9]{64}$/.test(expected) || !globalThis.crypto?.subtle) return false;
      try {
        const buffer = await globalThis.crypto.subtle.digest('SHA-256', new TextEncoder().encode(normalized));
        const actual = Array.from(new Uint8Array(buffer), (byte) => byte.toString(16).padStart(2, '0')).join('');
        return actual === expected;
      } catch { return false; }
    }

    async findTrigger() {
      const param = String(this.config.param || 'mystery').toLowerCase();
      const entries = [...this.entryUrl.searchParams];
      const explicit = entries.filter(([key]) => key.toLowerCase() === param);
      if (explicit.length) {
        const candidate = String(explicit[0][1] || '').trim();
        if (!candidate || !explicit.every(([, value]) => sameCode(value, candidate))) return null;
        return await this.matchesCode(candidate) ? { type: 'link', code: candidate } : null;
      }
      const normalize = (value) => String(value || '').replace(/\+/g, ' ').replace(/\s+/g, ' ').trim();
      const campaign = normalize(this.config.emailCampaign);
      if (!campaign) return null;
      const read = (name) => entries.find(([key]) => key.toLowerCase() === name)?.[1] || '';
      if (read('utm_source').toLowerCase() !== 'shopify_email' || read('utm_medium').toLowerCase() !== 'email') return null;
      if (normalize(read('utm_campaign')) !== campaign) return null;
      let cart;
      try { cart = await fetchJson(`${rootUrl()}cart.js`); } catch { return null; }
      for (const item of Array.isArray(cart.discount_codes) ? cart.discount_codes : []) {
        const candidate = String(item.code || '').trim();
        if (!await this.matchesCode(candidate)) continue;
        const storageKey = `cz-md-campaign:${candidate.toUpperCase()}:${campaign}:${this.config.endsAt || ''}`;
        try { if (sessionStorage.getItem(storageKey) === '1') return null; } catch {}
        return { type: 'email', code: candidate, storageKey };
      }
      return null;
    }

    findRecovery() {
      const fragments = new URLSearchParams(this.entryUrl.hash.slice(1));
      const values = fragments.getAll('cz-recover');
      if (!values.length) return null;
      this.invalidRecovery = true;
      if (values.length !== 1 || !values[0]) return null;
      try {
        const url = new URL(values[0]);
        const origins = new Set([location.origin]);
        if (this.config.storeUrl) origins.add(new URL(this.config.storeUrl).origin);
        if (this.config.shopDomain) origins.add(new URL(`https://${this.config.shopDomain}`).origin);
        if (url.protocol !== 'https:' || url.username || url.password || !origins.has(url.origin)) return null;
        if (!/^\/(?:\d+\/)?checkouts\/[^?#]+$/.test(url.pathname)) return null;
        this.invalidRecovery = false;
        return url;
      } catch { return null; }
    }

    recoveryDestination() {
      if (!this.recoveryUrl) return null;
      const url = new URL(this.recoveryUrl.href);
      if (!this.expired()) {
        url.searchParams.set('discount', this.code);
      }
      return url.href;
    }

    cleanUrl() {
      try {
        const url = new URL(location.href);
        for (const key of [...url.searchParams.keys()]) {
          if (key.toLowerCase() === this.config.param.toLowerCase()) url.searchParams.delete(key);
        }
        const fragments = new URLSearchParams(url.hash.slice(1));
        if (fragments.has('cz-recover')) {
          fragments.delete('cz-recover');
          url.hash = fragments.toString();
        }
        history.replaceState(history.state, '', url.href);
      } catch {}
    }

    async applyCode() {
      let result = { state: 'fallback', cart: null };
      try {
        let cart = await fetchJson(`${rootUrl()}cart.js`);
        const existing = Array.isArray(cart.discount_codes) ? cart.discount_codes : [];
        let discount = existing.find((item) => sameCode(item.code, this.code));
        if (!discount) {
          if (this.expired()) return { state: 'expired', cart };
          const codes = [...new Set(existing.map((item) => item.code).filter(Boolean))];
          if (codes.length >= 5) return result;
          cart = await fetchJson(`${rootUrl()}cart/update.js`, {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: [...codes, this.code].join(',') }),
          });
          discount = (cart.discount_codes || []).find((item) => sameCode(item.code, this.code));
        }
        if (discount?.applicable === true) result = { state: 'applied', cart };
        else if (discount && cart.item_count === 0) result = { state: 'saved', cart };
        else result = { state: 'fallback', cart };
        if (discount) this.refreshCart(cart);
      } catch {}
      if (this.expired()) result.state = 'expired';
      publish('cz_mystery_applied', { code: this.code, state: result.state });
      return result;
    }

    async refreshCart(cart) {
      try {
        if (!cart?.item_count) return;
        const { DiscountUpdateEvent } = await import('@theme/events');
        document.dispatchEvent(new DiscountUpdateEvent(cart, `cz-mystery-${this.sectionId}`));
      } catch {}
    }

    open(trigger) {
      if (!this.isConnected || this.dialog.open || (!this.designMode && this.expired())) return;
      clearTimeout(this.closeTimer);
      this.closing = false;
      this.revealed = false;
      this.dialog.classList.remove('is-revealed', 'is-closing', 'is-intro', 'is-animated', 'has-status');
      this.applied.dataset.state = 'pending';
      this.appliedText.textContent = '';
      this.appliedSub.textContent = '';
      this.announcement.hidden = true;
      if (this.recoveryUrl) this.querySelector('[data-cz-md-cta]').textContent = this.config.recoveryButton;
      this.previousFocus = document.activeElement;
      try { this.dialog.showModal(); } catch { return; }
      if (!this.designMode && this.trigger?.storageKey) {
        try { sessionStorage.setItem(this.trigger.storageKey, '1'); } catch {}
      }
      document.documentElement.classList.add('cz-md-scroll-lock');
      this.startCountdown();
      if (!this.designMode) publish('cz_mystery_view', { code: this.code, trigger });
      if (reducedMotion()) { this.reveal('instant'); return; }
      this.dialog.classList.add('is-intro', 'is-animated');
      this.revealTimer = setTimeout(() => this.reveal('auto'), 1350);
    }

    reveal(method) {
      if (this.revealed || !this.dialog.open || this.closing) return;
      this.revealed = true;
      clearTimeout(this.revealTimer);
      this.dialog.classList.add('is-revealed');
      if (!this.designMode) publish('cz_mystery_reveal', { code: this.code, method });
      this.statusTimer = setTimeout(() => this.showStatus(), method === 'instant' ? 0 : 700);
    }

    async showStatus() {
      if (this.designMode) { this.setStatus('applied', this.config.appliedText, this.config.appliedNote); return; }
      this.slowTimer = setTimeout(() => this.setStatus('applying', this.config.applyingText), 150);
      const result = await this.applyPromise;
      clearTimeout(this.slowTimer);
      if (this.expired() || result?.state === 'expired') this.setStatus('expired', this.config.expiredText);
      else if (result?.state === 'recovery') this.setStatus('recovery', this.config.recoveryText, this.config.recoveryNote);
      else if (result?.state === 'invalid-recovery') this.setStatus('fallback', this.config.invalidRecovery);
      else if (result?.state === 'applied') this.setStatus('applied', this.config.appliedText, this.config.appliedNote);
      else if (result?.state === 'saved') this.setStatus('saved', this.config.savedText, this.config.savedNote);
      else this.setStatus('fallback', this.config.fallbackText, this.config.fallbackNote);
    }

    setStatus(state, text, sub = '') {
      if (!this.isConnected || !this.dialog.open || this.closing) return;
      this.applied.dataset.state = state;
      this.appliedText.textContent = text || '';
      this.appliedSub.textContent = sub;
      this.announcement.hidden = state === 'expired';
      this.dialog.classList.add('has-status');
    }

    timeLeft(ms) {
      const total = Math.floor(ms / 60000);
      if (total < 1) return this.config.lessThanMinute;
      const days = Math.floor(total / 1440);
      const hours = Math.floor(total % 1440 / 60);
      const minutes = total % 60;
      const unit = (number, name) => {
        try { return new Intl.NumberFormat(this.config.locale || 'en', { style: 'unit', unit: name, unitDisplay: 'long' }).format(number); }
        catch { return `${number}${{ day: 'd', hour: 'h', minute: 'm' }[name]}`; }
      };
      if (days) return [unit(days, 'day'), hours ? unit(hours, 'hour') : ''].filter(Boolean).join(' ');
      if (hours) return [unit(hours, 'hour'), minutes ? unit(minutes, 'minute') : ''].filter(Boolean).join(' ');
      return unit(minutes, 'minute');
    }

    startCountdown() {
      clearInterval(this.tick);
      this.countdown.hidden = !this.config.showCountdown || this.endsAt === null;
      if (this.endsAt === null || this.designMode && this.invalidEnd) return;
      const update = () => {
        if (this.expired()) {
          clearInterval(this.tick);
          if (!this.designMode) this.setStatus('expired', this.config.expiredText);
          this.countdown.textContent = this.config.expiredText;
          return;
        }
        this.countdown.textContent = this.config.countdownText.replace('[time]', this.timeLeft(this.endsAt - Date.now()));
      };
      update();
      if (!this.expired()) this.tick = setInterval(update, 1000);
    }

    close(method) {
      if (!this.dialog.open || this.closing) return;
      this.closing = true;
      ['revealTimer', 'statusTimer', 'slowTimer'].forEach((key) => clearTimeout(this[key]));
      clearInterval(this.tick);
      if (!this.designMode) publish('cz_mystery_close', { code: this.code, method });
      const finish = () => {
        this.dialog.close();
        this.dialog.classList.remove('is-closing', 'is-intro', 'is-revealed', 'is-animated', 'has-status');
        this.unlockScroll();
        this.closing = false;
        if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      };
      if (reducedMotion()) finish();
      else { this.dialog.classList.add('is-closing'); this.closeTimer = setTimeout(finish, 220); }
    }

    onClick = async (event) => {
      if (event.target === this.dialog) { this.close('backdrop'); return; }
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      if (target.closest('[data-cz-md-close]')) { this.close('button'); return; }
      if (target.closest('[data-cz-md-tag]')) { this.reveal('tap'); return; }
      const cta = target.closest('[data-cz-md-cta]');
      if (!cta) return;
      event.preventDefault();
      if (cta.getAttribute('aria-busy') === 'true') return;
      if (this.designMode) { this.close('editor'); return; }
      publish('cz_mystery_cta', { code: this.code });
      cta.setAttribute('aria-busy', 'true');
      await this.applyPromise;
      cta.removeAttribute('aria-busy');
      if (!this.isConnected || !this.dialog.open || this.closing) return;
      this.close('cta');
      const recovery = this.recoveryDestination();
      if (recovery) location.assign(recovery);
      else if (!this.invalidRecovery && cta instanceof HTMLAnchorElement) location.assign(cta.href);
    };

    unlockScroll() {
      if (!document.querySelector('cz-mystery-discount dialog[open]')) document.documentElement.classList.remove('cz-md-scroll-lock');
    }

    setupEditor(signal) {
      const key = `cz-md-editor:${this.sectionId}`;
      const remember = (on) => { try { on ? sessionStorage.setItem(key, '1') : sessionStorage.removeItem(key); } catch {} };
      document.addEventListener('shopify:section:select', (event) => {
        if (event.detail?.sectionId !== this.sectionId) return;
        remember(true); this.open('editor');
      }, { signal });
      document.addEventListener('shopify:section:deselect', (event) => {
        if (event.detail?.sectionId !== this.sectionId) return;
        remember(false); this.close('editor');
      }, { signal });
      const messages = [];
      if (!this.config.active) messages.push(this.config.editorDisabled);
      if (this.invalidEnd) messages.push(this.config.editorInvalidEnd);
      else if (this.expired()) messages.push(this.config.editorExpired);
      const note = this.querySelector('[data-cz-md-editor-note]');
      if (note && messages.length) { note.textContent = messages.join(' '); note.hidden = false; }
      try { if (sessionStorage.getItem(key) === '1') this.openTimer = setTimeout(() => this.open('editor'), 150); } catch {}
    }
  }
  customElements.define('cz-mystery-discount', CzMysteryDiscount);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rush-cart"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rush-cart-banner')) {
    customElements.define('rush-cart-banner', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.sequence = 0;
        this.code = (this.dataset.code || '').trim().toUpperCase();
        if (this.dataset.editor === 'true') {
          this.hidden = false;
          return;
        }
        if (this.dataset.active !== 'true' || !this.code) return;

        document.addEventListener('discount:update', event => {
          const cart = event.detail?.resource;
          if (Array.isArray(cart?.discount_codes) && typeof cart.item_count === 'number') {
            this.sequence++;
            this.showFor(cart);
          } else this.refresh();
        }, { signal });
        document.addEventListener('cart:update', () => this.refresh(), { signal });
        window.addEventListener('pageshow', () => this.refresh(), { signal });
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.refresh();
        }, { signal });
        this.interval = window.setInterval(() => {
          if (!document.hidden) this.refresh();
        }, 30000);
        this.refresh();
      }

      disconnectedCallback() {
        this.sequence++;
        this.controller?.abort();
        window.clearInterval(this.interval);
      }

      async refresh() {
        const sequence = ++this.sequence;
        const root = (window.Shopify?.routes?.root || '/').replace(/\/$/, '');
        try {
          const response = await fetch(`${root}/cart.js`, {
            credentials: 'same-origin', cache: 'no-store',
            headers: { Accept: 'application/json' },
            signal: this.controller.signal,
          });
          if (!response.ok) throw new Error('Cart unavailable');
          const cart = await response.json();
          if (this.isConnected && sequence === this.sequence) this.showFor(cart);
        } catch {
          if (this.isConnected && sequence === this.sequence) this.hidden = true;
        }
      }

      showFor(cart) {
        const applicable = Array.isArray(cart?.discount_codes) && cart.discount_codes.some(discount =>
          String(discount.code || '').trim().toUpperCase() === this.code && discount.applicable === true
        );
        if (!applicable || !(Number(cart.item_count) > 0)) {
          this.hidden = true;
          return;
        }

        this.hidden = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
